import React, { useState, useEffect } from "react";
import { Button, Input, Form, FormGroup, Label } from "reactstrap";
import { useNavigate } from "react-router-dom";
import { journalSearchApi } from "src/network/api";
import Pagination from "./Pagination";
import { STATIC } from "src/network/networkConfig";
import CountrySelector from "./CountrySelector";

import { IssuesSelector } from "src/utils/appUtils";

const JournalCard = ({ searchQuery }) => {
  const [filters, setFilters] = useState({
    country: "",
    journal_name: "",
    publication_type: "",
    number_of_issue_per_year: "",
    review_type: "",
    limit: 10,
  });

  const [cards, setCards] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [error, setError] = useState("");

  const limit = 10;
  const navigate = useNavigate();
  const fetchJournals = async (currentPage: number) => {
    const offset = currentPage;
    setLoading(true);
    try {
      const response = await journalSearchApi({
        limit,
        offset,
        country: filters.country || "",
        publication_type: filters.publication_type || "",
        number_of_issue_per_year: filters.number_of_issue_per_year || "",
        review_type: filters.review_type || "",
        name: searchQuery,
      });

      console.log("Filters:", filters);

      const { data } = response;
      setCards(data.data || []);
      setTotalPages(data.totalPages || 0);
      // setCurrentPage(data.currentPage || 1);
    } catch (err) {
      setError("Failed to fetch journals. Please try again later.");
      console.error("Error fetching journals:", err);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchJournals(page);
  }, [page]);

  useEffect(() => {
    if (page == 1) {
      fetchJournals(page);
    } else {
      setPage(1);
    }
  }, [filters, searchQuery]);

  console.log("Selected Country:", filters.country);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters({ ...filters, [name]: value });
  };

  const handleCountrySelect = (countryId) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      country: countryId,
    }));
  };

  const handleNavigate = (journal_id) => {
    navigate(`/journal-profile/${journal_id}`);
  };

  return (
    <div className="container-fluid mt-4">
      <div className="row">
        {/* Filter Section */}
        <div className="col-md-3 mb-4">
          <div
            style={{
              padding: "20px",
              background: "white",
              borderRadius: "12px",
              boxShadow: "5px 5px 10px #d1d1d4, -5px -5px 10px #ffffff",
            }}
          >
            <h5 style={{ color: "#333", fontWeight: "bold" }}>
              Filter Journals
            </h5>
            <Form>
              <FormGroup>
                <CountrySelector
                  currentCountry={filters.country}
                  onSelectCountryCallback={handleCountrySelect}
                />
              </FormGroup>

              <FormGroup>
                <IssuesSelector
                  name="number_of_issue_per_year"
                  label=""
                  value={filters.number_of_issue_per_year}
                  onChange={handleFilterChange}
                  required={false}
                  className="filter-input"
                  style={{ borderRadius: "8px", padding: "10px" }}
                  control={undefined}
                />
              </FormGroup>

              <FormGroup>
                <Input
                  type="select"
                  name="publication_type"
                  value={filters.publication_type}
                  onChange={handleFilterChange}
                  style={{ borderRadius: "8px", padding: "10px" }}
                >
                  <option value="">Select Type</option>
                  <option value="Free">Free</option>
                  <option value="Paid">Paid</option>
                </Input>
              </FormGroup>

              <Button
                color="primary"
                onClick={() =>
                  setFilters({
                    ...filters,
                    country: "",
                    publication_type: "",
                    number_of_issue_per_year: "",
                  })
                }
                style={{
                  borderRadius: "8px",
                  //background: "#fca5a5",
                  border: "none",
                  padding: "5px 10px",
                  fontWeight: "bold",
                  width: "100%",
                }}
              >
                Reset Filters
              </Button>
            </Form>
          </div>
        </div>

        {/* Cards Section */}
        <div className="col-md-9 d-flex flex-column align-items-center justify-content-center">
          {loading ? (
            <div className="d-flex justify-content-center">
              <div
                className="alert alert-primary text-center fw-bold"
                style={{
                  fontSize: "1.1rem",
                  padding: "10px 20px",
                  borderRadius: "8px",
                }}
              >
                <i className="fas fa-spinner fa-spin me-2"></i> Loading, please
                wait...
              </div>
            </div>
          ) : cards.length === 0 ? (
            <div className="d-flex justify-content-center">
              <div
                className="alert alert-danger text-center fw-bold"
                style={{
                  fontSize: "1.1rem",
                  padding: "5px 10px",
                  borderRadius: "8px",
                }}
              >
                <i className="fas fa-exclamation-circle me-2"></i> No journals
                found. Try adjusting your filters.
              </div>
            </div>
          ) : (
            <div className="row">
              {cards.map((card, index) => (
                <div
                  key={index}
                  className="col-12 mb-4"
                  onClick={() => handleNavigate(card.journal_id)}
                  style={{
                    cursor: "pointer",
                    background: "#fff",
                    borderRadius: "12px",
                    boxShadow: "5px 5px 10px #d1d1d4, -5px -5px 10px #ffffff",
                    padding: "20px",
                    position: "relative",
                  }}
                >
                  <div>
                    <div className="row align-items-center">
                      <div className="col-12 col-md-3 text-center mb-3 mb-md-0">
                        <img
                          src={card.image || STATIC.noImageURL}
                          alt="Journal"
                          className=" img-fluid border"
                          style={{
                            width: "120px",
                            height: "120px",
                            objectFit: "cover",
                            borderWidth: "3px",
                            borderColor: "#e0e0e0",
                          }}
                        />
                      </div>
                      <div className="col-12 col-md-9">
                        <div className="d-flex justify-content-between align-items-center mb-3 flex-column flex-md-row">
                          <div>
                            <h5 className="card-title text-dark fw-bold mb-1">
                              {card.journal_name}
                            </h5>
                          </div>
                        </div>

                        <div className="d-flex flex-wrap gap-3 mt-3">
                          {[
                            { label: "Country", value: card.country_name },
                            //{ label: "State", value: card.state },
                            { label: "E-ISSN", value: card.eissn_no },
                            { label: "P-ISSN", value: card.pissn_no },
                            {
                              label: "Publisher Name",
                              value: card.publisher_name,
                            },
                            {
                              label: "Area",
                              value: card.broad_research_area,
                            },
                            {
                              label: "Impact Factor",
                              value: card.impact_factor,
                            },
                            {
                              label: "Language",
                              value: card.language,
                            },
                          ].map((tag, idx) => (
                            <div
                              key={idx}
                              className="px-3 py-2 rounded-pill pillls"
                              style={{
                                backgroundColor: "white",
                                color: "#0d6efd",
                                fontSize: "14px",
                                fontWeight: "500",
                                margin: "4px",
                                border: "1px solid #5E72E4",
                                boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                                transition: "all 0.2s ease",
                              }}
                            >
                              <span
                                style={{
                                  fontWeight: "400",
                                  color: "#495057",
                                  transition:
                                    "color 0.3s ease, text-decoration 0.3s ease",
                                }}
                                className="span-text hover-label"
                              >
                                {tag.label}:
                              </span>{" "}
                              <strong className="text-dark">{tag.value}</strong>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}

          {cards.length > 0 && (
            <div className="text-center w-100">
              <Pagination total={totalPages} page={page} setPage={setPage} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default JournalCard;
